import { Injectable, WritableSignal, signal } from '@angular/core';
import { IPageMetadata } from 'src/app/pages/type-routes/type-route.models.js';

@Injectable({
	providedIn: 'root'
})
export class SharedService {
	public readonly pageMetadata: WritableSignal<IPageMetadata | undefined> = signal(undefined);

	updateMetadata(metadata: IPageMetadata | undefined): void {
		this.pageMetadata.set(metadata);
	}
}
